module.exports = __webpack_public_path__ + "img/csv-dropzone.47dc3d04.svg";